module.exports = __webpack_public_path__ + "static/media/Clean-Juice.460ebc5c.pdf";